import { render, staticRenderFns } from "./FlexmessageModalPreview.vue?vue&type=template&id=190d0e77&scoped=true&"
import script from "./FlexmessageModalPreview.vue?vue&type=script&lang=js&"
export * from "./FlexmessageModalPreview.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageModalPreview.vue?vue&type=style&index=0&id=190d0e77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d0e77",
  null
  
)

export default component.exports